export default __webpack_public_path__ + "static/media/bangkok.cfdba0cc.png";